/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import styles from './Table.module.scss'

export const TableSkeleton: React.FC = () => {
  return (
    <div className={styles.root}>
      <table className={styles.table}>

        <thead>
          <tr>
            <th>&nbsp;</th>
            <th><Skeleton /></th>
            <th><Skeleton /></th>
            <th><Skeleton /></th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          {/* <tr> */}
          {/*  <td>Кэшбэк на кредиты</td> */}
          {/*  <td>Нет</td> */}
          {/*  <td> */}
          {/*    50 - 100 руб. */}
          {/*    <div className={styles.descr}>получайте на свой счет при оформлении займа</div> */}
          {/*  </td> */}
          {/*  <td> */}
          {/*    100 - 150 руб. */}
          {/*    <div className={styles.descr}>получайте на свой счет при оформлении займа</div> */}
          {/*  </td> */}
          {/* </tr> */}

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>

          <tr>
            <td>&nbsp;</td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>
        </tbody>

      </table>
    </div>
  )
}
